// AGC: Wagmi configuration for FarmProHub apps (Desktop mode)
// AGC: Integrates Coinbase Wallet (with Smart Wallet), MetaMask, and RainbowKit
// AGC: Optimized for Base blockchain and Hardhat local development

import { getDefaultConfig } from '@rainbow-me/rainbowkit'
import { hardhat, baseSepolia, base, supportedChains } from './networks'
import { http } from 'wagmi'
import { getAppMetadata } from './app-metadata'

/**
 * AGC: Get RPC URLs from environment
 */
const baseSepoliaRpc =
  import.meta.env.VITE_BASE_SEPOLIA_RPC_URL ||
  import.meta.env.VITE_BASE_RPC_URL ||
  'https://sepolia.base.org'

const baseMainnetRpc =
  import.meta.env.VITE_BASE_MAINNET_RPC_URL ||
  'https://mainnet.base.org'

/**
 * AGC: Create desktop config using RainbowKit's getDefaultConfig
 * AGC: This automatically includes MetaMask, Coinbase, WalletConnect, etc.
 */
export const createDesktopConfig = (projectId?: string) => {
  const metadata = getAppMetadata()
  
  return getDefaultConfig({
    appName: metadata.name,
    projectId: projectId || '6d0eaa5614ab4d62a37e712a7de9addf', // AGC: Default Reown Project ID
    chains: supportedChains,
    transports: {
      [baseSepolia.id]: http(baseSepoliaRpc),
      [base.id]: http(baseMainnetRpc),
      [hardhat.id]: http('http://127.0.0.1:8545'),
    },
    ssr: false,
    walletConnectParameters: {
      metadata: {
        name: metadata.name,
        description: metadata.description,
        url: typeof window !== 'undefined' ? window.location.origin : metadata.url,
        icons: typeof window !== 'undefined' ? [`${window.location.origin}/favicon.ico`] : []
      }
    }
  })
}

// AGC: Default desktop config (uses default project ID)
export const desktopConfig = createDesktopConfig()

/**
 * AGC: RainbowKit theme configuration
 * AGC: Purple accent matching FarmProHub theme
 */
export const rainbowKitTheme = {
  accentColor: '#7b3ff2',
  accentColorForeground: 'white',
  borderRadius: 'medium',
  fontStack: 'system',
  overlayBlur: 'small',
} as const

